import createVueComponent from '../createVueComponent';

const Bath = createVueComponent('BathIcon', [
  [
    'path',
    {
      d: 'M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5',
      key: '1r8yf5',
    },
  ],
  ['line', { x1: '10', x2: '8', y1: '5', y2: '7', key: 'h5g8z4' }],
  ['line', { x1: '2', x2: '22', y1: '12', y2: '12', key: '1dnqot' }],
  ['line', { x1: '7', x2: '7', y1: '19', y2: '21', key: '16jp00' }],
  ['line', { x1: '17', x2: '17', y1: '19', y2: '21', key: '1pxrnk' }],
]);

export default Bath;
